import { SetFixedViewTime } from '../_actions/ModelViewerStoreActions';
import type ModelViewerStore from '../_stores/ModelViewerStore';
import { useAppDispatch } from '../../Common/_hooks/useAppDispatch';
import { useAppSelector } from '../../Common/_hooks/useAppSelector';
import { useCallback } from 'react';

export default function useFixedViewTime(): [ModelViewerStore['fixedViewTime'], (view: ModelViewerStore['fixedViewTime']) => void] {
    const dispatch = useAppDispatch();
    const fixedViewTime = useAppSelector(state => state.get('UIData').get('designLab').get('modelViewer').get('fixedViewTime'))
    const setFixedViewTime = useCallback((time: number) => dispatch(SetFixedViewTime(time)), [dispatch])
    return [
        fixedViewTime,
        setFixedViewTime,
    ]
}
